import React, { useState, useEffect } from 'react';
import { FiClock, FiPlus, FiEdit2, FiTrash2, FiRefreshCw } from 'react-icons/fi';
import './Admin.css';

const ManageShift = () => {
  const [shifts, setShifts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingShift, setEditingShift] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    Ca: '',
    GioBatDau: '',
    GioKetThuc: ''
  });

  // Fetch shifts from API
  useEffect(() => {
    fetchShifts();
  }, []);

  const fetchShifts = async () => {
    try {
      setLoading(true);
      const response = await fetch('https://doticom.vn:3000/api/sale-ca-lam');
      if (response.ok) {
        const data = await response.json();
        setShifts(data);
      } else {
        console.error('Failed to fetch shifts');
      }
    } catch (error) {
      console.error('Error fetching shifts:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (editingShift) {
        // Update existing shift
        const response = await fetch(`https://doticom.vn:3000/api/sale-ca-lam/${editingShift.ID}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });

        if (response.ok) {
          alert('Cập nhật ca làm thành công');
          fetchShifts();
        } else {
          const error = await response.json();
          alert(`Lỗi: ${error.message}`);
        }
      } else {
        // Add new shift
        const response = await fetch('https://doticom.vn:3000/api/sale-ca-lam', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });

        if (response.ok) {
          alert('Thêm ca làm thành công');
          fetchShifts();
        } else {
          const error = await response.json();
          alert(`Lỗi: ${error.message}`);
        }
      }
      resetForm();
    } catch (error) {
      console.error('Error saving shift:', error);
      alert('Có lỗi xảy ra khi lưu ca làm');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (shift) => {
    setEditingShift(shift);
    setFormData({
      Ca: shift.Ca,
      GioBatDau: shift.GioBatDau,
      GioKetThuc: shift.GioKetThuc
    });
    setShowModal(true);
  };

  const handleDelete = async (shiftId) => {
    if (window.confirm('Bạn có chắc chắn muốn xóa ca làm này?')) {
      setLoading(true);
      try {
        const response = await fetch(`https://doticom.vn:3000/api/sale-ca-lam/${shiftId}`, {
          method: 'DELETE'
        });

        if (response.ok) {
          alert('Xóa ca làm thành công');
          fetchShifts();
        } else {
          const error = await response.json();
          alert(`Lỗi: ${error.message}`);
        }
      } catch (error) {
        console.error('Error deleting shift:', error);
        alert('Có lỗi xảy ra khi xóa ca làm');
      } finally {
        setLoading(false);
      }
    }
  };

  const resetForm = () => {
    setFormData({
      Ca: '',
      GioBatDau: '',
      GioKetThuc: ''
    });
    setEditingShift(null);
    setShowModal(false);
  };

  const openAddModal = () => {
    resetForm();
    setShowModal(true);
  };

  const formatTime = (timeString) => {
    if (!timeString) return '';
    // Handle different time formats from API
    if (timeString.includes('T')) {
      return timeString.split('T')[1].substring(0, 5);
    }
    return timeString.substring(0, 5);
  };

  return (
    <div className="admin-layout">
      <div className="admin-main" style={{ marginLeft: 0 }}>
        <header className="admin-header">
          <div className="header-left">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <FiClock size={32} color="#495057" />
              <div>
                <h1>Quản lý ca làm</h1>
                <p>Quản lý ca làm việc của nhân viên</p>
              </div>
            </div>
          </div>
          <div className="header-right">
            <button 
              className="btn btn-primary"
              onClick={openAddModal}
              disabled={loading}
            >
              <FiPlus className="me-1" />
              {loading ? 'Đang xử lý...' : 'Thêm ca làm mới'}
            </button>
          </div>
        </header>

        <div className="content-section">
          <div className="card">
            <div className="card-body">
              {loading ? (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Đang tải...</span>
                  </div>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Tên ca</th>
                        <th>Giờ bắt đầu</th>
                        <th>Giờ kết thúc</th>
                        <th>Thao tác</th>
                      </tr>
                    </thead>
                    <tbody>
                      {shifts.map(shift => (
                        <tr key={shift.ID}>
                          <td>{shift.ID}</td>
                          <td>{shift.Ca}</td>
                          <td>{formatTime(shift.GioBatDau)}</td>
                          <td>{formatTime(shift.GioKetThuc)}</td>
                          <td>
                            <button 
                              className="btn btn-outline-primary btn-sm me-2" 
                              onClick={() => handleEdit(shift)}
                              disabled={loading}
                            >
                              <FiEdit2 className="me-1" />
                              Sửa
                            </button>
                            <button 
                              className="btn btn-outline-danger btn-sm" 
                              onClick={() => handleDelete(shift.ID)}
                              disabled={loading}
                            >
                              <FiTrash2 className="me-1" />
                              Xóa
                            </button>
                          </td>
                        </tr>
                      ))}
                      {shifts.length === 0 && !loading && (
                        <tr>
                          <td colSpan="5" style={{ textAlign: 'center', padding: '40px', color: '#6c757d' }}>
                            Chưa có ca làm nào
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>{editingShift ? 'Sửa ca làm' : 'Thêm ca làm mới'}</h3>
              <button className="modal-close" onClick={resetForm}>×</button>
            </div>
            <form onSubmit={handleSubmit} className="modal-body">
              <div className="form-group">
                <label htmlFor="Ca">Tên ca:</label>
                <input
                  type="text"
                  id="Ca"
                  name="Ca"
                  className="form-control"
                  value={formData.Ca}
                  onChange={handleInputChange}
                  placeholder="VD: Ca sáng, Ca chiều, Ca tối"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="GioBatDau">Giờ bắt đầu:</label>
                <input
                  type="time"
                  id="GioBatDau"
                  name="GioBatDau"
                  className="form-control"
                  value={formData.GioBatDau}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="GioKetThuc">Giờ kết thúc:</label>
                <input
                  type="time"
                  id="GioKetThuc"
                  name="GioKetThuc"
                  className="form-control"
                  value={formData.GioKetThuc}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={resetForm}
                  disabled={loading}
                >
                  Hủy
                </button>
                <button 
                  type="submit" 
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? 'Đang xử lý...' : (editingShift ? 'Cập nhật' : 'Thêm mới')}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageShift;
